import apiOrganizations from '@/api/organizations';

const organizationsState = {
    projects: [],
    users: []
};

const organizations = {
    namespaced: true,
    state: JSON.parse(JSON.stringify(organizationsState)),
    mutations: {
        setProjects(state, payload) {
            state.projects = payload;
        },
        setUsers(state, payload) {
            state.users = payload;
        },
        reset(state) {
            state.projects = [];
            state.users = [];
        }
    },
    actions: {
        async getProjects({ commit, rootState, rootGetters }) {
            const projects = await apiOrganizations.projects
                .get(
                    rootState.user.status.idToken,
                    rootGetters['view/organization'].organizationId
                )
                .then(response => response.data.items)
                .catch(() => []);
            commit('setProjects', projects);
        },
        async getUsers({ commit, rootState, rootGetters }) {
            const users = await apiOrganizations.users
                .get(
                    rootState.user.status.idToken,
                    rootGetters['view/organization'].organizationId
                )
                .then(response => response.data.items)
                .catch(() => []);
            commit('setUsers', users);
        },
        setProjects({ commit }, response) {
            commit('setProjects', response);
        },
        setUsers({ commit }, response) {
            commit('setUsers', response);
        },
        reset({ commit }) {
            commit('reset');
        }
    }
};

export default organizations;
